
<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>FAQ</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="inner-title"  >
          <h4>FAQ</h4>
         
        </div>
      </div>
      <div class="col-md-6">
        <div id="accordion" class="accordion">
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" href="#c1">
              <a class="card-title">What are the documents required for admission?</a>
            </div>
            <div id="c1" class="card-body collapse in show" data-parent="#accordion" >
             <p> <strong>Answer: </strong>12th marksheet original, TC original 10 marksheet xerox, migration needed for the candiadtes from other state</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c2">
              <a class="card-title">Which Branches are available for admission?</a>
            </div>
            <div id="c2" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Bachelor of Business Administration (BBA) & Bachelor of Commerce (Computer Application)</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c3">
              <a class="card-title">What is the intake of college?</a>
            </div>
            <div id="c3" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>BBA 240 BCCA 240</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c4">
              <a class="card-title">Where will I get admission form?</a>
            </div>
            <div id="c4" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Online and counseling centre.</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c5">
              <a class="card-title">What will be the Time Schedule of Admission?</a>
            </div>
            <div id="c5" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>9 AM to 5 PM</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c6">
              <a class="card-title">Is there is any provision for Sports Quota Admission?</a>
            </div>
            <div id="c6" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Yes</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c7">
              <a class="card-title">What is the scope for students after BBA/BCA/BCCA?</a>
            </div>
            <div id="c7" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>MBA, M.Com, PGDCCA, PGDBM, PGDM, MCA, MCM and own business</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c8">
              <a class="card-title">What is the timing of college?</a>
            </div>
            <div id="c8" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>9:30 to 2:00</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c9">
              <a class="card-title">Do you have qualified and experienced faculty?</a>
            </div>
            <div id="c9" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Yes</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c10">
              <a class="card-title">What is the Mode of payments?</a>
            </div>
            <div id="c10" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Online tranfer, Cheque, DD or cash</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c11">
              <a class="card-title">Part Payments facility is Available or not?</a>
            </div>
            <div id="c11" class="card-body collapse" data-parent="#accordion" >
              <p><strong>Answer: </strong>Yes</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div id="accordion2" class="accordion">
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" href="#c12">
              <a class="card-title">Can I pay fees in installments?</a>
            </div>
            <div id="c12" class="card-body collapse in show" data-parent="#accordion" >
                <p><strong>Answer: </strong>Yes</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c13">
              <a class="card-title">What is Admission Cancellation Policy?</a>
            </div>
            <div id="c13" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>-</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c14">
              <a class="card-title">Is there any scholarship for student?</a>
            </div>
            <div id="c14" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>only for SC ST</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c15">
              <a class="card-title">Is there any Linguistic minority scholarship?</a>
            </div>
            <div id="c15" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Yes (muslims, Jain, Christian)</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c16">
              <a class="card-title">Does the college provide hostel facility?</a>
            </div>
            <div id="c16" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Yes in hariganga campus</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c17">
              <a class="card-title">What may be the annual fee structure of bus?</a>
            </div>
            <div id="c17" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>NA</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c18">
              <a class="card-title">What is the extra-curricular activity in your college?</a>
            </div>
            <div id="c18" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Toastmasters, Management Fest, Industrial tour, Industrial visits, RPL, annual gathering, Charter Chariot, short term courses, </p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c19">
              <a class="card-title">How are the placements in your college?</a>
            </div>
            <div id="c19" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Mainly students go for PG courses</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c20">
              <a class="card-title">Which companies are visiting your campus for recruitment?</a>
            </div>
            <div id="c20" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>TCS, Dell, Airtel, ICICI, Concentrix, Amazon, IBM Daksh, just Dial, axis bank, Motif India, yellemchilli etc</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c21">
              <a class="card-title">Do have Placement assistance or training program?</a>
            </div>
            <div id="c21" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Yes</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c22">
              <a class="card-title">What are the USP of college?</a>
            </div>
            <div id="c22" class="card-body collapse" data-parent="#accordion2" >
              <p><strong>Answer: </strong>Toastmasters Club and RPL</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
